export interface SelectedMenuItem {
  id?: string;
  menuId?: string;
}
